import { Component, OnInit } from '@angular/core';
import { RecSearchService } from '../../../rec-search/rec-search-service'
import { DocTypeVM } from '../../viewmodels/ISearchService';
import { DocTypeCIF } from '../../../shared/viewmodels/UtilityObj';
import { Store } from '@ngrx/store';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';

@Component({
  selector: 'app-doctypeex',
  templateUrl: './doctypeex.component.html',
  styleUrls: ['./doctypeex.component.css']
})
export class DoctypeexComponent implements OnInit {

  public utilityobj: DocTypeCIF;
  message: any;
  error: any;
  //public docTypes: DocTypeVM[];
  toggleCheck: boolean = false;
  public isChecked: boolean = false;
  public selectedDocs: string = "All Doc Types";

  constructor(private service: RecSearchService, private store: Store<AppState>) {
  
  }

  ngOnInit() {

    this.utilityobj = new DocTypeCIF();
    this.store.select(getRegSearchState).subscribe(data => this.message = data);

    //if (this.message.rec[0].doctypes.length != 0) {

    if (this.message.doct.doct != undefined && this.message.doct.doct[0] != null) {
      this.utilityobj.doctypes = this.message.doct.doct[0].doctypes;

      if (this.message.doct.doct[0] != null && this.message.doct.doct[0].doctypes.length != 0) {
        this.utilityobj.doctypes = this.message.doct.doct[0].doctypes;
        var selectedDocs = this.utilityobj.doctypes.filter(function (value) { return value["isChecked"] == true; });
        var docString = "";
        selectedDocs.forEach(t => docString = `${docString} ${t.docName}`);
        this.selectedDocs = docString;
        console.log('type - ' + docString.length);
        if (docString.length === 0)
          this.selectedDocs = "All Doc Types";
        else if (docString.length > 50)
          this.selectedDocs = docString.substring(0, 50) + '...';
      }
    }
    else {
      this.getDocTypes();
    }

  }

  getDocTypes() {
    this.service.getDocTypes().subscribe(
      data => {

        this.utilityobj.doctypes = data
        this.utilityobj.doctypes.forEach(function(value) {
            value["isChecked"] = false;

          }
        );

      },
      error => { this.error = error }
    );
  }

  docSelected(docType) {
    //console.log(`citySelected fired event: ${JSON.stringify(city)}`);

    this.utilityobj.doctypes = this.utilityobj.doctypes.map((val) => ({
      ...val
    }));

    var selectedDocs = this.utilityobj.doctypes.filter(function (value) { return value["isChecked"] == true; });

    //console.log(`selctedTowns: ${JSON.stringify(selectedTowns)}`);
    var docsString = "";
    selectedDocs.forEach(t => docsString = `${docsString} ${t.docName}`);
    this.selectedDocs = docsString;
    if (docsString.length === 0)
      this.selectedDocs = "All Doc Types";
    else if (docsString.length > 50)
      this.selectedDocs = this.selectedDocs.substring(0, 50) + '...';

  }

  checkAll(event) {
    //if (this.toggleCheck) {
      //this.utilityobj.doctypes.forEach(function (val) {
      //  val["isChecked"] = false;
      //});

    this.utilityobj.doctypes = this.utilityobj.doctypes.map((val) => ({
      ...val,
      isChecked: false,
    }));


      this.isChecked = false;
      this.selectedDocs = "All Doc Types"
    //}
    //else {
    //  this.utilityobj.doctypes.forEach(function (val) {
    //    val["isChecked"] = true;
    //  });
    //  this.isChecked = true;
    //  this.selectedDocs = "All Doc Types"
    //}
    this.toggleCheck = !this.toggleCheck;
  }
}
